export const programGeneratorSVG = {
  header: {
    regenerateWorkout: (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.06945 3.63167C6.46812 2.46501 8.08012 2.42967 8.55278 3.52567L8.59278 3.63234L9.13078 5.20567C9.25408 5.5665 9.45332 5.89668 9.71507 6.17396C9.97682 6.45123 10.295 6.66915 10.6481 6.81301L10.7928 6.86701L12.3661 7.40434C13.5328 7.80301 13.5681 9.41501 12.4728 9.88767L12.3661 9.92768L10.7928 10.4657C10.4318 10.5889 10.1015 10.7881 9.82413 11.0498C9.54673 11.3116 9.32871 11.6298 9.18478 11.983L9.13078 12.127L8.59345 13.701C8.19478 14.8677 6.58278 14.903 6.11078 13.8077L6.06945 13.701L5.53212 12.1277C5.4089 11.7667 5.2097 11.4364 4.94794 11.159C4.68619 10.8816 4.36798 10.6636 4.01478 10.5197L3.87078 10.4657L2.29745 9.92834C1.13012 9.52967 1.09478 7.91767 2.19078 7.44567L2.29745 7.40434L3.87078 6.86701C4.23161 6.74371 4.56179 6.54447 4.83907 6.28272C5.11634 6.02097 5.33426 5.7028 5.47812 5.34967L5.53212 5.20567L6.06945 3.63167ZM12.6648 1.33301C12.7895 1.33301 12.9117 1.36799 13.0176 1.43399C13.1234 1.49998 13.2086 1.59434 13.2635 1.70634L13.2955 1.78434L13.5288 2.46834L14.2135 2.70167C14.3384 2.74414 14.448 2.82275 14.5283 2.92755C14.6085 3.03235 14.6559 3.15862 14.6643 3.29036C14.6727 3.42209 14.6419 3.55336 14.5756 3.66753C14.5093 3.7817 14.4107 3.87363 14.2921 3.93167L14.2135 3.96367L13.5295 4.19701L13.2961 4.88167C13.2536 5.00663 13.1749 5.11614 13.0701 5.19634C12.9652 5.27653 12.8389 5.3238 12.7072 5.33216C12.5755 5.34051 12.4442 5.30957 12.3301 5.24326C12.216 5.17695 12.1241 5.07825 12.0661 4.95967L12.0341 4.88167L11.8008 4.19767L11.1161 3.96434C10.9911 3.92188 10.8816 3.84326 10.8013 3.73846C10.721 3.63366 10.6737 3.5074 10.6653 3.37566C10.6568 3.24393 10.6877 3.11265 10.754 2.99848C10.8202 2.88431 10.9189 2.79238 11.0375 2.73434L11.1161 2.70234L11.8001 2.46901L12.0335 1.78434C12.0784 1.65262 12.1635 1.53828 12.2767 1.45734C12.3899 1.3764 12.5256 1.33292 12.6648 1.33301Z"
          fill="white"
          fillOpacity="0.7"
        />
      </svg>
    ),
    assignToClient: (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 16C10.85 16 9.775 16.175 8.775 16.525C7.775 16.875 6.85 17.3667 6 18V20H18V18C17.15 17.3667 16.225 16.875 15.225 16.525C14.225 16.175 13.15 16 12 16ZM6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.19667 21.0217 4.00067 20.5507 4 20V4C4 3.45 4.196 2.97933 4.588 2.588C4.98 2.19667 5.45067 2.00067 6 2H18C18.55 2 19.021 2.196 19.413 2.588C19.805 2.98 20.0007 3.45067 20 4V20C20 20.55 19.8043 21.021 19.413 21.413C19.0217 21.805 18.5507 22.0007 18 22H6ZM12 14C12.9667 14 13.7917 13.6583 14.475 12.975C15.1583 12.2917 15.5 11.4667 15.5 10.5C15.5 9.53333 15.1583 8.70833 14.475 8.025C13.7917 7.34167 12.9667 7 12 7C11.0333 7 10.2083 7.34167 9.525 8.025C8.84167 8.70833 8.5 9.53333 8.5 10.5C8.5 11.4667 8.84167 12.2917 9.525 12.975C10.2083 13.6583 11.0333 14 12 14Z"
          fill="white"
          fillOpacity="0.7"
        />
      </svg>
    ),
    viewInLibrary: (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.67188 8H13.3385M9.33854 4L13.3385 8L9.33854 12"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  sidebar: {
    exerciseLibraryClose: (
      <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 21L21 11M11 11L21 21"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    exercisePickerDots: (
      <svg
        width={13}
        height={24}
        viewBox="0 0 13 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 7C5 7.82843 4.32843 8.5 3.5 8.5C2.67157 8.5 2 7.82843 2 7C2 6.17157 2.67157 5.5 3.5 5.5C4.32843 5.5 5 6.17157 5 7Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M11 7C11 7.82843 10.3284 8.5 9.5 8.5C8.67157 8.5 8 7.82843 8 7C8 6.17157 8.67157 5.5 9.5 5.5C10.3284 5.5 11 6.17157 11 7Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M11 12C11 12.8284 10.3284 13.5 9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5C10.3284 10.5 11 11.1716 11 12Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M5 12C5 12.8284 4.32843 13.5 3.5 13.5C2.67157 13.5 2 12.8284 2 12C2 11.1716 2.67157 10.5 3.5 10.5C4.32843 10.5 5 11.1716 5 12Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M5 17C5 17.8284 4.32843 18.5 3.5 18.5C2.67157 18.5 2 17.8284 2 17C2 16.1716 2.67157 15.5 3.5 15.5C4.32843 15.5 5 16.1716 5 17Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M11 17C11 17.8284 10.3284 18.5 9.5 18.5C8.67157 18.5 8 17.8284 8 17C8 16.1716 8.67157 15.5 9.5 15.5C10.3284 15.5 11 16.1716 11 17Z"
          fill="white"
          fillOpacity="0.5"
        />
      </svg>
    ),
    toggle: (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 5.667C7 4.95967 7.28099 4.28131 7.78115 3.78115C8.28131 3.28099 8.95967 3 9.667 3H18.333C18.6832 3 19.03 3.06898 19.3536 3.20301C19.6772 3.33704 19.9712 3.53349 20.2189 3.78115C20.4665 4.0288 20.663 4.32281 20.797 4.64638C20.931 4.96996 21 5.31676 21 5.667V14.333C21 14.6832 20.931 15.03 20.797 15.3536C20.663 15.6772 20.4665 15.9712 20.2189 16.2189C19.9712 16.4665 19.6772 16.663 19.3536 16.797C19.03 16.931 18.6832 17 18.333 17H9.667C8.95967 17 8.28131 16.719 7.78115 16.2189C7.28099 15.7187 7 15.0403 7 14.333V5.667Z"
          stroke="#04051B"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.012 7.26C3.705 7.43443 3.44965 7.68702 3.2719 7.99211C3.09415 8.2972 3.00034 8.64391 3 8.997V18.997C3 20.097 3.9 20.997 5 20.997H15C15.75 20.997 16.158 20.612 16.5 19.997M11 7H16M11 10H17M11 13H14"
          stroke="#04051B"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  exerciseType: {
    warmup: (
      <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="url(#paint0_linear_12314_32092)"
        />
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="white"
          fillOpacity="0.03"
        />
        <path
          d="M16 0.125C24.7675 0.125 31.875 7.23248 31.875 16C31.875 24.7675 24.7675 31.875 16 31.875C7.23248 31.875 0.125 24.7675 0.125 16C0.125 7.23248 7.23248 0.125 16 0.125Z"
          stroke="white"
          strokeOpacity="0.15"
          strokeWidth="0.25"
        />
        <path
          d="M21.6699 15.2447C21.44 14.9613 21.16 14.7158 20.9001 14.4702C20.2302 13.9035 19.4703 13.4974 18.8305 12.9024C17.3407 11.5234 17.0108 9.24727 17.9606 7.5C17.0108 7.71723 16.1809 8.20835 15.4711 8.7467C12.8815 10.7112 11.8617 14.1774 13.0815 17.1525C13.1215 17.2469 13.1615 17.3414 13.1615 17.4642C13.1615 17.672 13.0115 17.8609 12.8116 17.9364C12.5816 18.0309 12.3416 17.9742 12.1517 17.8231C12.0949 17.7782 12.0475 17.7237 12.0117 17.6625C10.8819 16.3119 10.7019 14.3758 11.4618 12.8268C9.79211 14.1113 8.88228 16.2836 9.01225 18.3331C9.07224 18.8053 9.13223 19.2776 9.3022 19.7498C9.44218 20.3165 9.71213 20.8832 10.0121 21.3837C11.0919 23.0177 12.9615 24.1888 14.9712 24.4249C17.1108 24.6799 19.4004 24.3116 21.0401 22.9138C22.8697 21.346 23.5096 18.8337 22.5698 16.6803L22.4398 16.4347C22.2298 16.0002 21.6699 15.2447 21.6699 15.2447ZM18.5105 21.1948C18.2306 21.4215 17.7707 21.6671 17.4107 21.7615C16.2909 22.1393 15.1711 21.6104 14.5112 20.9871C15.701 20.7226 16.4109 19.8915 16.6209 19.0509C16.7908 18.2953 16.4709 17.672 16.3409 16.9447C16.2209 16.2458 16.2409 15.6508 16.5109 14.9991C16.7008 15.358 16.9008 15.7169 17.1408 16.0002C17.9106 16.9447 19.1204 17.3603 19.3804 18.6448C19.4203 18.777 19.4403 18.9092 19.4403 19.0509C19.4703 19.8254 19.1104 20.6754 18.5105 21.1948Z"
          fill="#E5E5E5"
        />
        <defs>
          <linearGradient
            id="paint0_linear_12314_32092"
            x1="33.45"
            y1="32.0083"
            x2="8.59413"
            y2="-8.20779"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#13142B" />
            <stop offset={1} stopColor="#050621" />
          </linearGradient>
        </defs>
      </svg>
    ),
    main: (
      <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="url(#paint0_linear_12314_32169)"
        />
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="white"
          fillOpacity="0.03"
        />
        <path
          d="M16 0.125C24.7675 0.125 31.875 7.23248 31.875 16C31.875 24.7675 24.7675 31.875 16 31.875C7.23248 31.875 0.125 24.7675 0.125 16C0.125 7.23248 7.23248 0.125 16 0.125Z"
          stroke="white"
          strokeOpacity="0.15"
          strokeWidth="0.25"
        />
        <path
          d="M22.5069 17.7451C23.8622 17.0587 24.3918 15.4281 23.6897 14.1031C22.9876 12.778 21.3197 12.2603 19.9643 12.9467C18.609 13.6331 18.0794 15.2637 18.7815 16.5888C19.4836 17.9138 21.1515 18.4315 22.5069 17.7451Z"
          fill="#E5E5E5"
        />
        <path
          d="M16.5086 10.3837C17.2063 10.3837 17.7737 10.9386 17.7737 11.6205V13.6022C18.1974 13.4737 18.5481 13.2271 18.7345 12.8538C19.209 11.9045 18.969 10.3351 17.3391 9.37693C15.09 8.0725 13.5501 7.57188 10.8152 7.31911C8.80082 7.28332 8.31958 8.53793 8.09898 9.6171C8.01853 10.0102 7.96952 10.3269 8.02135 10.5831C8.02651 10.6684 8.03756 10.7541 8.0582 10.8401L9.30122 16.0048L8.76704 22.7005C8.70108 23.5269 9.33303 24.2492 10.1785 24.3137C10.2191 24.3168 10.2594 24.3184 10.2994 24.3184C11.0931 24.3184 11.7658 23.7207 11.8285 22.9341L12.3812 16.0054C12.3935 15.851 12.3812 15.6956 12.3451 15.5449L11.441 11.7882C12.8136 12.1566 14.1535 12.7415 15.2435 13.2043V11.6205C15.2435 10.9386 15.811 10.3837 16.5086 10.3837Z"
          fill="#E5E5E5"
        />
        <path
          d="M17.4913 19.3601V11.6205C17.4913 11.09 17.0513 10.6599 16.5086 10.6599C15.966 10.6599 15.526 11.09 15.526 11.6205V19.3601C15.8315 19.2458 16.1625 19.1825 16.5086 19.1825C16.8546 19.1826 17.1858 19.2458 17.4913 19.3601Z"
          fill="#E5E5E5"
        />
        <path
          d="M16.5086 19.4588C15.1418 19.4588 14.0338 20.542 14.0338 21.8783C14.0338 23.2145 15.1418 24.2978 16.5086 24.2978C17.8755 24.2978 18.9835 23.2145 18.9835 21.8783C18.9835 20.542 17.8755 19.4588 16.5086 19.4588ZM16.5086 23.0169C15.8654 23.0169 15.344 22.5071 15.344 21.8783C15.344 21.2494 15.8654 20.7397 16.5086 20.7397C17.1519 20.7397 17.6733 21.2494 17.6733 21.8783C17.6732 22.507 17.1518 23.0169 16.5086 23.0169Z"
          fill="#E5E5E5"
        />
        <path
          d="M16.5086 22.4565C16.8353 22.4565 17.1001 22.1976 17.1001 21.8783C17.1001 21.5589 16.8353 21.3001 16.5086 21.3001C16.182 21.3001 15.9172 21.5589 15.9172 21.8783C15.9172 22.1976 16.182 22.4565 16.5086 22.4565Z"
          fill="#E5E5E5"
        />
        <defs>
          <linearGradient
            id="paint0_linear_12314_32169"
            x1="33.45"
            y1="32.0083"
            x2="8.59413"
            y2="-8.20779"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#13142B" />
            <stop offset={1} stopColor="#050621" />
          </linearGradient>
        </defs>
      </svg>
    ),
    cooldown: (
      <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="url(#paint0_linear_12314_32284)"
        />
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="white"
          fillOpacity="0.03"
        />
        <path
          d="M16 0.125C24.7675 0.125 31.875 7.23248 31.875 16C31.875 24.7675 24.7675 31.875 16 31.875C7.23248 31.875 0.125 24.7675 0.125 16C0.125 7.23248 7.23248 0.125 16 0.125Z"
          stroke="white"
          strokeOpacity="0.15"
          strokeWidth="0.25"
        />
        <path
          d="M22.6158 18.9248L21.5169 18.3111C21.7157 18.113 21.9438 17.9445 22.1937 17.8111C22.3571 17.722 22.4774 17.5742 22.5286 17.3997C22.5797 17.2253 22.5575 17.0384 22.4668 16.8797C22.3761 16.721 22.2243 16.6033 22.0443 16.5524C21.8643 16.5014 21.6708 16.5213 21.5059 16.6076C21.0288 16.8629 20.606 17.2033 20.2599 17.6107L17.4122 16.0186L20.2593 14.4292C20.6053 14.8367 21.0281 15.1771 21.5053 15.4323C21.587 15.4769 21.6772 15.5054 21.7704 15.5161C21.8636 15.5268 21.9581 15.5196 22.0485 15.4949C22.1388 15.4701 22.2231 15.4283 22.2967 15.3718C22.3702 15.3154 22.4314 15.2454 22.4768 15.1659C22.5222 15.0865 22.5509 14.9991 22.5612 14.9089C22.5715 14.8187 22.5633 14.7274 22.5369 14.6402C22.5105 14.5531 22.4665 14.4719 22.4075 14.4013C22.3485 14.3307 22.2756 14.2721 22.1931 14.2289C21.9432 14.0953 21.7152 13.9268 21.5163 13.7289L22.6152 13.1151C22.6992 13.0717 22.7734 13.0123 22.8332 12.9406C22.8931 12.8689 22.9374 12.7863 22.9636 12.6976C22.9898 12.609 22.9973 12.5162 22.9856 12.4248C22.974 12.3333 22.9434 12.245 22.8958 12.1652C22.8481 12.0854 22.7844 12.0156 22.7083 11.9601C22.6322 11.9046 22.5454 11.8644 22.4529 11.842C22.3605 11.8196 22.2643 11.8153 22.1701 11.8296C22.076 11.8438 21.9857 11.8762 21.9047 11.9248L20.8058 12.5382C20.7276 12.2726 20.6903 11.9972 20.6953 11.7211C20.6974 11.6306 20.6809 11.5407 20.647 11.4564C20.613 11.3721 20.5622 11.2951 20.4974 11.2298C20.4326 11.1646 20.3551 11.1123 20.2694 11.0761C20.1837 11.0398 20.0914 11.0203 19.9978 11.0186H19.9846C19.7983 11.0185 19.6194 11.0892 19.4864 11.2154C19.3534 11.3415 19.277 11.5131 19.2735 11.6932C19.2635 12.2201 19.3567 12.744 19.5482 13.2373L16.7011 14.8276V11.6492C17.239 11.5632 17.7553 11.3795 18.2224 11.1076C18.384 11.0135 18.5002 10.8612 18.5456 10.6842C18.591 10.5072 18.5619 10.3201 18.4645 10.1639C18.3672 10.0077 18.2097 9.89527 18.0266 9.85138C17.8436 9.80748 17.65 9.83569 17.4884 9.9298C17.2435 10.0721 16.9782 10.1786 16.7011 10.2457V9.20605C16.7011 9.02372 16.6262 8.84885 16.4928 8.71992C16.3595 8.59099 16.1786 8.51855 15.99 8.51855C15.8015 8.51855 15.6206 8.59099 15.4872 8.71992C15.3539 8.84885 15.279 9.02372 15.279 9.20605V10.2457C15.0019 10.1786 14.7365 10.0721 14.4916 9.9298C14.3301 9.83569 14.1365 9.80748 13.9535 9.85138C13.7704 9.89527 13.6129 10.0077 13.5156 10.1639C13.4182 10.3201 13.389 10.5072 13.4344 10.6842C13.4798 10.8612 13.5961 11.0135 13.7576 11.1076C14.2248 11.3795 14.741 11.5632 15.279 11.6492V14.8276L12.4318 13.2373C12.6237 12.7438 12.7171 12.2197 12.7072 11.6926C12.7037 11.5125 12.6273 11.3409 12.4943 11.2147C12.3613 11.0886 12.1825 11.0179 11.9962 11.0179H11.9823C11.8889 11.0196 11.7967 11.039 11.7111 11.0751C11.6255 11.1112 11.5481 11.1633 11.4833 11.2283C11.4185 11.2934 11.3676 11.3701 11.3335 11.4542C11.2994 11.5382 11.2827 11.628 11.2844 11.7182C11.2897 11.9948 11.2525 12.2706 11.1742 12.5367L10.0753 11.9248C9.9944 11.8781 9.90469 11.8475 9.81141 11.8346C9.71813 11.8218 9.62313 11.827 9.53194 11.8499C9.44075 11.8729 9.35519 11.9131 9.28023 11.9683C9.20527 12.0235 9.1424 12.0926 9.09528 12.1715C9.04817 12.2503 9.01774 12.3375 9.00576 12.4279C8.99379 12.5182 9.00051 12.61 9.02554 12.6978C9.05057 12.7857 9.0934 12.8678 9.15155 12.9395C9.2097 13.0112 9.28201 13.071 9.36427 13.1154L10.4632 13.7292C10.2643 13.9272 10.0362 14.0956 9.78638 14.2292C9.70382 14.2724 9.63092 14.331 9.57191 14.4016C9.5129 14.4722 9.46893 14.5534 9.44255 14.6405C9.41616 14.7277 9.40788 14.819 9.41819 14.9092C9.4285 14.9994 9.45718 15.0868 9.50259 15.1663C9.548 15.2457 9.60924 15.3157 9.68276 15.3721C9.75629 15.4286 9.84065 15.4704 9.93098 15.4952C10.0213 15.5199 10.1158 15.5272 10.209 15.5164C10.3023 15.5057 10.3924 15.4772 10.4742 15.4326C10.9513 15.1773 11.374 14.8369 11.7201 14.4295L14.5679 16.0186L11.7208 17.6079C11.3747 17.2005 10.9519 16.8601 10.4748 16.6048C10.393 16.5602 10.3029 16.5317 10.2097 16.521C10.1165 16.5103 10.022 16.5175 9.93162 16.5423C9.8413 16.567 9.75693 16.6088 9.68341 16.6653C9.60988 16.7217 9.54865 16.7917 9.50324 16.8712C9.45783 16.9506 9.42914 17.038 9.41884 17.1282C9.40853 17.2184 9.41681 17.3098 9.44319 17.3969C9.46958 17.484 9.51354 17.5652 9.57256 17.6358C9.63157 17.7064 9.70446 17.765 9.78703 17.8082C10.0369 17.9418 10.2649 18.1103 10.4638 18.3082L9.36427 18.9248C9.28201 18.9692 9.2097 19.029 9.15155 19.1007C9.0934 19.1724 9.05057 19.2546 9.02554 19.3424C9.00051 19.4302 8.99379 19.522 9.00576 19.6124C9.01774 19.7027 9.04817 19.7899 9.09528 19.8688C9.1424 19.9477 9.20527 20.0167 9.28023 20.0719C9.35519 20.1271 9.44075 20.1674 9.53194 20.1903C9.62313 20.2133 9.71813 20.2185 9.81141 20.2056C9.90469 20.1928 9.9944 20.1621 10.0753 20.1154L11.1742 19.502C11.2525 19.7676 11.2898 20.043 11.2848 20.3192C11.2815 20.5013 11.3531 20.6773 11.4839 20.8084C11.6146 20.9395 11.7939 21.0151 11.9823 21.0186H11.9955C12.1818 21.0186 12.3607 20.9479 12.4937 20.8217C12.6266 20.6956 12.7031 20.524 12.7066 20.3439C12.7166 19.817 12.6234 19.2931 12.4318 18.7998L15.279 17.2095V20.3879C14.741 20.4739 14.2248 20.6577 13.7576 20.9295C13.5961 21.0236 13.4798 21.1759 13.4344 21.3529C13.389 21.5299 13.4182 21.7171 13.5156 21.8732C13.6129 22.0294 13.7704 22.1418 13.9535 22.1857C14.1365 22.2296 14.3301 22.2014 14.4916 22.1073C14.7365 21.965 15.0019 21.8586 15.279 21.7914V22.8311C15.279 23.0134 15.3539 23.1883 15.4872 23.3172C15.6206 23.4461 15.8015 23.5186 15.99 23.5186C16.1786 23.5186 16.3595 23.4461 16.4928 23.3172C16.6262 23.1883 16.7011 23.0134 16.7011 22.8311V21.7914C16.9782 21.8586 17.2435 21.965 17.4884 22.1073C17.65 22.2014 17.8436 22.2296 18.0266 22.1857C18.2097 22.1418 18.3672 22.0294 18.4645 21.8732C18.5619 21.7171 18.591 21.5299 18.5456 21.3529C18.5002 21.1759 18.384 21.0236 18.2224 20.9295C17.7553 20.6577 17.239 20.4739 16.7011 20.3879V17.2095L19.5482 18.7998C19.3564 19.2933 19.263 19.8174 19.2729 20.3445C19.2763 20.5246 19.3528 20.6962 19.4858 20.8224C19.6187 20.9485 19.7976 21.0192 19.9839 21.0192H19.9978C20.0912 21.0175 20.1833 20.9981 20.2689 20.962C20.3546 20.9259 20.432 20.8738 20.4968 20.8088C20.5616 20.7438 20.6125 20.667 20.6466 20.583C20.6807 20.4989 20.6974 20.4092 20.6956 20.3189C20.6904 20.0423 20.7275 19.7665 20.8058 19.5004L21.9047 20.1139C21.9857 20.1641 22.0763 20.198 22.1711 20.2134C22.266 20.2288 22.363 20.2254 22.4565 20.2035C22.55 20.1816 22.6378 20.1416 22.7149 20.0859C22.7919 20.0302 22.8564 19.96 22.9045 19.8795C22.9526 19.799 22.9834 19.7099 22.9949 19.6176C23.0064 19.5253 22.9984 19.4317 22.9714 19.3424C22.9444 19.2532 22.899 19.1702 22.8379 19.0984C22.7768 19.0266 22.7012 18.9675 22.6158 18.9248Z"
          fill="black"
        />
        <path
          d="M22.6158 18.9248L21.5169 18.3111C21.7157 18.113 21.9438 17.9445 22.1937 17.8111C22.3571 17.722 22.4774 17.5742 22.5286 17.3997C22.5797 17.2253 22.5575 17.0384 22.4668 16.8797C22.3761 16.721 22.2243 16.6033 22.0443 16.5524C21.8643 16.5014 21.6708 16.5213 21.5059 16.6076C21.0288 16.8629 20.606 17.2033 20.2599 17.6107L17.4122 16.0186L20.2593 14.4292C20.6053 14.8367 21.0281 15.1771 21.5053 15.4323C21.587 15.4769 21.6772 15.5054 21.7704 15.5161C21.8636 15.5268 21.9581 15.5196 22.0485 15.4949C22.1388 15.4701 22.2231 15.4283 22.2967 15.3718C22.3702 15.3154 22.4314 15.2454 22.4768 15.1659C22.5222 15.0865 22.5509 14.9991 22.5612 14.9089C22.5715 14.8187 22.5633 14.7274 22.5369 14.6402C22.5105 14.5531 22.4665 14.4719 22.4075 14.4013C22.3485 14.3307 22.2756 14.2721 22.1931 14.2289C21.9432 14.0953 21.7152 13.9268 21.5163 13.7289L22.6152 13.1151C22.6992 13.0717 22.7734 13.0123 22.8332 12.9406C22.8931 12.8689 22.9374 12.7863 22.9636 12.6976C22.9898 12.609 22.9973 12.5162 22.9856 12.4248C22.974 12.3333 22.9434 12.245 22.8958 12.1652C22.8481 12.0854 22.7844 12.0156 22.7083 11.9601C22.6322 11.9046 22.5454 11.8644 22.4529 11.842C22.3605 11.8196 22.2643 11.8153 22.1701 11.8296C22.076 11.8438 21.9857 11.8762 21.9047 11.9248L20.8058 12.5382C20.7276 12.2726 20.6903 11.9972 20.6953 11.7211C20.6974 11.6306 20.6809 11.5407 20.647 11.4564C20.613 11.3721 20.5622 11.2951 20.4974 11.2298C20.4326 11.1646 20.3551 11.1123 20.2694 11.0761C20.1837 11.0398 20.0914 11.0203 19.9978 11.0186H19.9846C19.7983 11.0185 19.6194 11.0892 19.4864 11.2154C19.3534 11.3415 19.277 11.5131 19.2735 11.6932C19.2635 12.2201 19.3567 12.744 19.5482 13.2373L16.7011 14.8276V11.6492C17.239 11.5632 17.7553 11.3795 18.2224 11.1076C18.384 11.0135 18.5002 10.8612 18.5456 10.6842C18.591 10.5072 18.5619 10.3201 18.4645 10.1639C18.3672 10.0077 18.2097 9.89527 18.0266 9.85138C17.8436 9.80748 17.65 9.83569 17.4884 9.9298C17.2435 10.0721 16.9782 10.1786 16.7011 10.2457V9.20605C16.7011 9.02372 16.6262 8.84885 16.4928 8.71992C16.3595 8.59099 16.1786 8.51855 15.99 8.51855C15.8015 8.51855 15.6206 8.59099 15.4872 8.71992C15.3539 8.84885 15.279 9.02372 15.279 9.20605V10.2457C15.0019 10.1786 14.7365 10.0721 14.4916 9.9298C14.3301 9.83569 14.1365 9.80748 13.9535 9.85138C13.7704 9.89527 13.6129 10.0077 13.5156 10.1639C13.4182 10.3201 13.389 10.5072 13.4344 10.6842C13.4798 10.8612 13.5961 11.0135 13.7576 11.1076C14.2248 11.3795 14.741 11.5632 15.279 11.6492V14.8276L12.4318 13.2373C12.6237 12.7438 12.7171 12.2197 12.7072 11.6926C12.7037 11.5125 12.6273 11.3409 12.4943 11.2147C12.3613 11.0886 12.1825 11.0179 11.9962 11.0179H11.9823C11.8889 11.0196 11.7967 11.039 11.7111 11.0751C11.6255 11.1112 11.5481 11.1633 11.4833 11.2283C11.4185 11.2934 11.3676 11.3701 11.3335 11.4542C11.2994 11.5382 11.2827 11.628 11.2844 11.7182C11.2897 11.9948 11.2525 12.2706 11.1742 12.5367L10.0753 11.9248C9.9944 11.8781 9.90469 11.8475 9.81141 11.8346C9.71813 11.8218 9.62313 11.827 9.53194 11.8499C9.44075 11.8729 9.35519 11.9131 9.28023 11.9683C9.20527 12.0235 9.1424 12.0926 9.09528 12.1715C9.04817 12.2503 9.01774 12.3375 9.00576 12.4279C8.99379 12.5182 9.00051 12.61 9.02554 12.6978C9.05057 12.7857 9.0934 12.8678 9.15155 12.9395C9.2097 13.0112 9.28201 13.071 9.36427 13.1154L10.4632 13.7292C10.2643 13.9272 10.0362 14.0956 9.78638 14.2292C9.70382 14.2724 9.63092 14.331 9.57191 14.4016C9.5129 14.4722 9.46893 14.5534 9.44255 14.6405C9.41616 14.7277 9.40788 14.819 9.41819 14.9092C9.4285 14.9994 9.45718 15.0868 9.50259 15.1663C9.548 15.2457 9.60924 15.3157 9.68276 15.3721C9.75629 15.4286 9.84065 15.4704 9.93098 15.4952C10.0213 15.5199 10.1158 15.5272 10.209 15.5164C10.3023 15.5057 10.3924 15.4772 10.4742 15.4326C10.9513 15.1773 11.374 14.8369 11.7201 14.4295L14.5679 16.0186L11.7208 17.6079C11.3747 17.2005 10.9519 16.8601 10.4748 16.6048C10.393 16.5602 10.3029 16.5317 10.2097 16.521C10.1165 16.5103 10.022 16.5175 9.93162 16.5423C9.8413 16.567 9.75693 16.6088 9.68341 16.6653C9.60988 16.7217 9.54865 16.7917 9.50324 16.8712C9.45783 16.9506 9.42914 17.038 9.41884 17.1282C9.40853 17.2184 9.41681 17.3098 9.44319 17.3969C9.46958 17.484 9.51354 17.5652 9.57256 17.6358C9.63157 17.7064 9.70446 17.765 9.78703 17.8082C10.0369 17.9418 10.2649 18.1103 10.4638 18.3082L9.36427 18.9248C9.28201 18.9692 9.2097 19.029 9.15155 19.1007C9.0934 19.1724 9.05057 19.2546 9.02554 19.3424C9.00051 19.4302 8.99379 19.522 9.00576 19.6124C9.01774 19.7027 9.04817 19.7899 9.09528 19.8688C9.1424 19.9477 9.20527 20.0167 9.28023 20.0719C9.35519 20.1271 9.44075 20.1674 9.53194 20.1903C9.62313 20.2133 9.71813 20.2185 9.81141 20.2056C9.90469 20.1928 9.9944 20.1621 10.0753 20.1154L11.1742 19.502C11.2525 19.7676 11.2898 20.043 11.2848 20.3192C11.2815 20.5013 11.3531 20.6773 11.4839 20.8084C11.6146 20.9395 11.7939 21.0151 11.9823 21.0186H11.9955C12.1818 21.0186 12.3607 20.9479 12.4937 20.8217C12.6266 20.6956 12.7031 20.524 12.7066 20.3439C12.7166 19.817 12.6234 19.2931 12.4318 18.7998L15.279 17.2095V20.3879C14.741 20.4739 14.2248 20.6577 13.7576 20.9295C13.5961 21.0236 13.4798 21.1759 13.4344 21.3529C13.389 21.5299 13.4182 21.7171 13.5156 21.8732C13.6129 22.0294 13.7704 22.1418 13.9535 22.1857C14.1365 22.2296 14.3301 22.2014 14.4916 22.1073C14.7365 21.965 15.0019 21.8586 15.279 21.7914V22.8311C15.279 23.0134 15.3539 23.1883 15.4872 23.3172C15.6206 23.4461 15.8015 23.5186 15.99 23.5186C16.1786 23.5186 16.3595 23.4461 16.4928 23.3172C16.6262 23.1883 16.7011 23.0134 16.7011 22.8311V21.7914C16.9782 21.8586 17.2435 21.965 17.4884 22.1073C17.65 22.2014 17.8436 22.2296 18.0266 22.1857C18.2097 22.1418 18.3672 22.0294 18.4645 21.8732C18.5619 21.7171 18.591 21.5299 18.5456 21.3529C18.5002 21.1759 18.384 21.0236 18.2224 20.9295C17.7553 20.6577 17.239 20.4739 16.7011 20.3879V17.2095L19.5482 18.7998C19.3564 19.2933 19.263 19.8174 19.2729 20.3445C19.2763 20.5246 19.3528 20.6962 19.4858 20.8224C19.6187 20.9485 19.7976 21.0192 19.9839 21.0192H19.9978C20.0912 21.0175 20.1833 20.9981 20.2689 20.962C20.3546 20.9259 20.432 20.8738 20.4968 20.8088C20.5616 20.7438 20.6125 20.667 20.6466 20.583C20.6807 20.4989 20.6974 20.4092 20.6956 20.3189C20.6904 20.0423 20.7275 19.7665 20.8058 19.5004L21.9047 20.1139C21.9857 20.1641 22.0763 20.198 22.1711 20.2134C22.266 20.2288 22.363 20.2254 22.4565 20.2035C22.55 20.1816 22.6378 20.1416 22.7149 20.0859C22.7919 20.0302 22.8564 19.96 22.9045 19.8795C22.9526 19.799 22.9834 19.7099 22.9949 19.6176C23.0064 19.5253 22.9984 19.4317 22.9714 19.3424C22.9444 19.2532 22.899 19.1702 22.8379 19.0984C22.7768 19.0266 22.7012 18.9675 22.6158 18.9248Z"
          fill="#E5E5E5"
        />
        <defs>
          <linearGradient
            id="paint0_linear_12314_32284"
            x1="33.45"
            y1="32.0083"
            x2="8.59413"
            y2="-8.20779"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#13142B" />
            <stop offset={1} stopColor="#050621" />
          </linearGradient>
        </defs>
      </svg>
    ),
    fitness: {},
    cardio: {},
    rest: {},
  },
  exerciseAction: {
    menu: (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
          stroke="#E5E5E5"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19Z"
          stroke="#E5E5E5"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 5C11 5.55229 11.4477 6 12 6C12.5523 6 13 5.55229 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5Z"
          stroke="#E5E5E5"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    duplicate: (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 6.0955C4 5.53974 4.22078 5.00674 4.61376 4.61376C5.00674 4.22078 5.53974 4 6.0955 4H12.9045C13.1797 4 13.4522 4.0542 13.7064 4.15951C13.9607 4.26482 14.1917 4.41917 14.3862 4.61376C14.5808 4.80834 14.7352 5.03935 14.8405 5.29359C14.9458 5.54782 15 5.82031 15 6.0955V12.9045C15 13.1797 14.9458 13.4522 14.8405 13.7064C14.7352 13.9607 14.5808 14.1917 14.3862 14.3862C14.1917 14.5808 13.9607 14.7352 13.7064 14.8405C13.4522 14.9458 13.1797 15 12.9045 15H6.0955C5.82031 15 5.54782 14.9458 5.29359 14.8405C5.03935 14.7352 4.80834 14.5808 4.61376 14.3862C4.41917 14.1917 4.26482 13.9607 4.15951 13.7064C4.0542 13.4522 4 13.1797 4 12.9045V6.0955Z"
          stroke="#E5E5E5"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.74963 11C1.52222 10.873 1.33307 10.6891 1.20141 10.4671C1.06974 10.245 1.00025 9.99257 1 9.73553V2.45592C1 1.65516 1.66667 1 2.48148 1H9.88889C10.4444 1 10.7467 1.28026 11 1.72796"
          stroke="#E5E5E5"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    replaceExercise: (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6841 8.78076L9.25078 11.0808C9.12856 11.2697 8.95923 11.3474 8.74278 11.3141C8.52634 11.2808 8.39011 11.153 8.33411 10.9308L7.86745 9.0641L3.31745 13.6141C3.19523 13.7363 3.04256 13.8003 2.85945 13.8061C2.67634 13.8119 2.51789 13.7479 2.38411 13.6141C2.26189 13.4919 2.20078 13.3363 2.20078 13.1474C2.20078 12.9585 2.26189 12.803 2.38411 12.6808L6.93411 8.1141L5.06745 7.64743C4.84523 7.59188 4.71745 7.45588 4.68411 7.23943C4.65078 7.02299 4.72856 6.85343 4.91745 6.73076L7.21745 5.3141L7.01745 2.59743C6.99523 2.37521 7.08411 2.2141 7.28411 2.1141C7.48412 2.0141 7.66745 2.03632 7.83411 2.18076L9.91745 3.93076L12.4341 2.9141C12.6452 2.82521 12.8286 2.85854 12.9841 3.0141C13.1397 3.16965 13.173 3.35299 13.0841 3.5641L12.0674 6.08076L13.8174 8.14743C13.9619 8.3141 13.9841 8.49743 13.8841 8.69743C13.7841 8.89743 13.623 8.98632 13.4008 8.9641L10.6841 8.78076ZM2.15078 4.3141C2.08411 4.24743 2.05078 4.16965 2.05078 4.08076C2.05078 3.99188 2.08411 3.9141 2.15078 3.84743L3.01745 2.98076C3.08411 2.9141 3.16189 2.88076 3.25078 2.88076C3.33967 2.88076 3.41745 2.9141 3.48411 2.98076L4.35078 3.84743C4.41745 3.9141 4.45078 3.99188 4.45078 4.08076C4.45078 4.16965 4.41745 4.24743 4.35078 4.3141L3.48411 5.18076C3.41745 5.24743 3.33967 5.28076 3.25078 5.28076C3.16189 5.28076 3.08411 5.24743 3.01745 5.18076L2.15078 4.3141ZM11.6841 13.8474L10.8174 12.9808C10.7508 12.9141 10.7174 12.8363 10.7174 12.7474C10.7174 12.6585 10.7508 12.5808 10.8174 12.5141L11.6841 11.6474C11.7508 11.5808 11.8286 11.5474 11.9174 11.5474C12.0063 11.5474 12.0841 11.5808 12.1508 11.6474L13.0174 12.5141C13.0841 12.5808 13.1174 12.6585 13.1174 12.7474C13.1174 12.8363 13.0841 12.9141 13.0174 12.9808L12.1508 13.8474C12.0841 13.9141 12.0063 13.9474 11.9174 13.9474C11.8286 13.9474 11.7508 13.9141 11.6841 13.8474Z"
          fill="#E5E5E5"
        />
      </svg>
    ),
    convertToSuperset: (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_13518_2699)">
          <path
            d="M8.66536 10.6663L6.66536 12.6663L8.66536 14.6663M6.66536 12.6663H9.9987C12.576 12.6663 14.6654 10.577 14.6654 7.99967C14.6654 6.13808 13.5753 4.53107 11.9987 3.7821M3.9987 12.2173C2.42207 11.4683 1.33203 9.86127 1.33203 7.99967C1.33203 5.42235 3.42137 3.33301 5.9987 3.33301H9.33203M7.33203 5.33301L9.33203 3.33301L7.33203 1.33301"
            stroke="#E5E5E5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_13518_2699">
            <rect width={16} height={16} fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    remove: (
      <svg
        width={16}
        height={18}
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.75 4.26647L13.0997 14.7895C13.0728 15.2268 12.9035 15.6361 12.6258 15.9349C12.3482 16.2337 11.9829 16.3998 11.6035 16.3998H5.3965C5.0171 16.3998 4.6518 16.2337 4.37416 15.9349C4.09653 15.6361 3.92719 15.2268 3.90025 14.7895L3.25 4.26647M7 7.73314V12.9331M10 7.73314V12.9331M10.75 4.26647V1.66647C10.75 1.43662 10.671 1.21618 10.5303 1.05365C10.3897 0.891114 10.1989 0.799805 10 0.799805H7C6.80109 0.799805 6.61032 0.891114 6.46967 1.05365C6.32902 1.21618 6.25 1.43662 6.25 1.66647V4.26647M2.5 4.26647H14.5"
          stroke="#E5E5E5"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    pasteContent: (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3408 4.72852C14.6477 4.72854 14.9422 4.85041 15.1592 5.06738C15.3759 5.28424 15.4979 5.5782 15.498 5.88477V6.41406C15.4979 6.76104 15.2162 7.04199 14.8691 7.04199C14.5222 7.04193 14.2404 6.76101 14.2402 6.41406V6.09668C14.2402 6.03515 14.1904 5.98535 14.1289 5.98535H12.7549C12.4079 5.98523 12.127 5.7035 12.127 5.35645C12.1271 5.00949 12.4079 4.72863 12.7549 4.72852H14.3408Z"
          fill="#E5E5E5"
          stroke="#E5E5E5"
          strokeWidth="0.2"
        />
        <path
          d="M14.8721 7.90039C15.2191 7.90039 15.5009 8.18129 15.501 8.52832V10.6426C15.501 10.9897 15.2192 11.2715 14.8721 11.2715C14.525 11.2714 14.2441 10.9896 14.2441 10.6426V8.52832C14.2443 8.18136 14.5251 7.90051 14.8721 7.90039Z"
          fill="#E5E5E5"
          stroke="#E5E5E5"
          strokeWidth="0.2"
        />
        <path
          d="M14.875 12.1289C15.2219 12.1291 15.5028 12.4099 15.5029 12.7568V14.3428C15.5029 14.6496 15.381 14.9442 15.1641 15.1611C14.9471 15.378 14.6525 15.5 14.3457 15.5H13.8174C13.4704 15.4999 13.1895 15.2182 13.1895 14.8711C13.1895 14.5241 13.4704 14.2423 13.8174 14.2422H14.1348C14.1963 14.2422 14.2461 14.1924 14.2461 14.1309V12.7568C14.2462 12.4098 14.5279 12.1289 14.875 12.1289Z"
          fill="#E5E5E5"
          stroke="#E5E5E5"
          strokeWidth="0.2"
        />
        <path
          d="M10.1152 0.5C10.4221 0.5 10.7166 0.621874 10.9336 0.838867C11.1503 1.05573 11.2723 1.34966 11.2725 1.65625V10.1133C11.2725 10.4202 11.1506 10.7146 10.9336 10.9316C10.7166 11.1486 10.4221 11.2705 10.1152 11.2705H1.6582C1.35161 11.2704 1.05769 11.1484 0.84082 10.9316C0.623827 10.7146 0.501953 10.4202 0.501953 10.1133V1.65625C0.502068 1.34953 0.623929 1.05576 0.84082 0.838867C1.05771 0.621976 1.35148 0.500115 1.6582 0.5H10.1152ZM2.1582 1.75684C1.93763 1.75707 1.75902 1.93568 1.75879 2.15625V9.61328C1.75879 9.83405 1.93749 10.0134 2.1582 10.0137H9.61523C9.83615 10.0137 10.0156 9.83419 10.0156 9.61328V2.15625C10.0154 1.93554 9.836 1.75684 9.61523 1.75684H2.1582Z"
          fill="#E5E5E5"
          stroke="#E5E5E5"
          strokeWidth="0.2"
        />
        <path
          d="M11.7051 14.2422C12.0521 14.2422 12.3339 14.5231 12.334 14.8701C12.334 15.2172 12.0522 15.499 11.7051 15.499H9.59082C9.24379 15.4989 8.96289 15.2172 8.96289 14.8701C8.96301 14.5232 9.24386 14.2423 9.59082 14.2422H11.7051Z"
          fill="#E5E5E5"
          stroke="#E5E5E5"
          strokeWidth="0.2"
        />
        <path
          d="M5.35645 12.1289C5.7035 12.1289 5.98523 12.4098 5.98535 12.7568V13.9199C5.9854 14.098 6.12954 14.242 6.30762 14.2422H7.4707C7.8178 14.2422 8.09955 14.524 8.09961 14.8711C8.09961 15.2182 7.81783 15.5 7.4707 15.5H5.88477C5.5782 15.4999 5.28424 15.3778 5.06738 15.1611C4.85041 14.9442 4.72854 14.6496 4.72852 14.3428V12.7568C4.72863 12.4099 5.00949 12.129 5.35645 12.1289Z"
          fill="#E5E5E5"
          stroke="#E5E5E5"
          strokeWidth="0.2"
        />
      </svg>
    ),
    backToProgram: (
      <svg
        width={12}
        height={16}
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_13651_6617)">
          <path
            d="M5.99835 2.19922C6.10371 2.19932 6.20871 2.22022 6.30597 2.26074C6.40317 2.30135 6.49253 2.36075 6.56671 2.43555L6.56769 2.43652C6.64247 2.51081 6.70195 2.59996 6.74249 2.69727C6.78297 2.79461 6.80402 2.89946 6.80402 3.00488C6.80398 3.11035 6.78303 3.21514 6.74249 3.3125C6.70199 3.40967 6.64235 3.49805 6.56769 3.57227L6.56671 3.57324L2.92413 7.20508H10.9984C11.2103 7.20526 11.4139 7.28958 11.5638 7.43945C11.7135 7.58944 11.7982 7.79293 11.7982 8.00488C11.7981 8.21685 11.7136 8.42037 11.5638 8.57031C11.4139 8.72016 11.2103 8.80451 10.9984 8.80469H2.92413L6.56671 12.4365C6.71722 12.5873 6.80206 12.7918 6.80206 13.0049C6.80201 13.2179 6.71727 13.4225 6.56671 13.5732C6.41609 13.7238 6.21133 13.8084 5.99835 13.8086C5.89307 13.8086 5.78804 13.7882 5.69073 13.748C5.59338 13.7077 5.50456 13.6477 5.42999 13.5732L0.432921 8.57617C0.360207 8.50021 0.303026 8.41052 0.264953 8.3125L0.263 8.30859C0.183123 8.11403 0.18321 7.89576 0.263 7.70117L0.264953 7.69727C0.302413 7.60072 0.35888 7.51176 0.429992 7.43652L5.42999 2.43555C5.50431 2.36068 5.59336 2.30131 5.69073 2.26074C5.78808 2.22027 5.89292 2.19922 5.99835 2.19922Z"
            fill="white"
            fillOpacity="0.7"
          />
        </g>
        <defs>
          <clipPath id="clip0_13651_6617">
            <rect width={12} height={16} fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  calender: (
    <svg width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66797 1.16602V3.49935"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33203 1.16602V3.49935"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0833 2.33398H2.91667C2.27233 2.33398 1.75 2.85632 1.75 3.50065V11.6673C1.75 12.3116 2.27233 12.834 2.91667 12.834H11.0833C11.7277 12.834 12.25 12.3116 12.25 11.6673V3.50065C12.25 2.85632 11.7277 2.33398 11.0833 2.33398Z"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 5.83398H12.25"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  weekProgram: {
    prevWeek: (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 18L12 12L18 6"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 18L5 12L11 6"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    nextWeek: (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 18L12 12L6 6"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 18L19 12L13 6"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    weekDropdownArrow: (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 9L12 15L18 9"
          stroke="white"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  EditExercise: {
    close: (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 18L18 6M6 6L18 18"
          stroke="#99A1AF"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
};
